import Head from 'next/head';
import Link from 'next/link';

import { SafetyGLFHHelpSEO } from '@/utils/constants/MetaData';

const SafetyOfGlfh = () => {
  return (
    <>
      <Head>
        <title>{SafetyGLFHHelpSEO.metaTitle}</title>
        <meta name="description" content={SafetyGLFHHelpSEO.metaDescription} />
        <meta
          property="og:description"
          content={SafetyGLFHHelpSEO.metaOGDescription}
        />
        <link
          rel="canonical"
          href="https://muthootfincorpone.com/help/gold-loans/safety-of-glfh/"
        />
      </Head>
      <main className="repayment singleFlow--lightBlue pledge setting">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link href="/help">Gold Loan Help</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Safety of Gold Loan Prime
              </li>
            </ol>
          </nav>
          <div className="loanDetails__card loanCard accordion setting-faq-accordion">
            <h1 className="loanCard__title text--bold text--black">
              Safety of Gold Loan Prime
            </h1>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingTwo"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                <p className="text--black text--semi title">
                  How do I trust the Muthoot FinCorp ONE Relationship Manager
                  visiting my house?
                </p>
              </div>
              <div
                id="collapseTwo"
                className="collapse"
                aria-labelledby="headingTwo"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Following are the steps we take to ensure you a hassle-free
                    experience:
                    <p>
                      • The name and employee code of your Dedicated
                      Relationship Manager are updated on the Muthoot FinCorp
                      ONE app on the day the appointment is scheduled.
                    </p>
                    <p>
                      • Then, an SMS with the same information is sent to your
                      registered mobile number.
                    </p>
                    <p>
                      • Once the Dedicated Relationship Manager reaches your
                      home, they will share an OTP that you need to enter on the
                      app to start the loan process.
                    </p>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default SafetyOfGlfh;
